import { useMutation } from "@apollo/client/react";
import { DSModal } from "@components/design-system/organisms/DSModal";
import NoteCreatedAt from "@components/notebook/note/NoteCreatedAt";
import Twemoji from "@src/Twemoji";
import mixpanel from "mixpanel-browser";
import { useNavigate } from "react-router-dom";

import { alert } from "../../common/Alert";
import { DELETE_NOTE } from "../edit/api/mutations";

export default function DeleteNoteModal({
  note,
  shouldShowDeleteNoteModal,
  setShouldShowDeleteNoteModal,
}) {
  const [deleteNote] = useMutation(DELETE_NOTE);
  const navigate = useNavigate();

  async function handleDelete() {
    try {
      await deleteNote({ variables: { noteUuid: note?.uuid } });
      mixpanel.track("Note Deleted", {
        noteUUID: note?.uuid,
      });
      alert("success", "Note deleted.");
      setShouldShowDeleteNoteModal(false);
    } catch {
      alert(
        "error",
        "Failed to delete note. Are you trying to delete a note you don't own?",
      );
    } finally {
      setShouldShowDeleteNoteModal(false);
      navigate("/dashboard");
    }
  }

  return (
    <DSModal
      isOpen={shouldShowDeleteNoteModal}
      onClose={() => setShouldShowDeleteNoteModal(false)}
      title="Delete Note"
      actions={[
        {
          label: "Cancel",
          variant: "cancel",
          onClick: () => setShouldShowDeleteNoteModal(false),
        },
        {
          label: "Delete",
          variant: "primary",
          onClick: handleDelete,
          dataTestId: "confirm-button",
        },
      ]}
      dataTestId="delete-note-modal"
    >
      <h5>
        Are you sure you&apos;d like to{" "}
        <strong>delete this note</strong>? This action cannot be
        undone.
      </h5>
      <h5 className="text-sm font-semibold mt-4">
        <Twemoji emoji={"📝"} /> {note?.title || "(Untitled Note)"}
      </h5>

      <NoteCreatedAt createdAt={note?.createdAt} />
    </DSModal>
  );
}
